import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { commandsClient } from '#pplx_generated/typespec/rest/commands/client.js';
export async function listAvailableSlashCommands(reason) {
    const { data, error, response } = await commandsClient.GET('/rest/commands/available', reason);
    if (error) {
        throw new ApiClientsError('API_CLIENTS_ERROR', {
            message: 'Failed to fetch available slash commands',
            cause: error,
            status: response.status ?? 0,
        });
    }
    return data;
}
//# sourceMappingURL=listAvailableSlashCommands.js.map